module.exports = __webpack_public_path__ + "gist-logo-d0568763cb499915bb5710030c0b5d0e.webp";